<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button icon="sync" @click="apiOrdersQueryListByCheck">刷新</a-button>
			</div>
		</div>
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="检票流水查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">服务商：</div>
						<a-select v-model="query.facilitatorId" @change="facilitatorChange">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="(item, index) in facilitatorList" :key="index" :value="item.facilitatorId">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">园门：</div>
						<a-select v-model="query.checkstationId" @change="checkstationChange">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="(item, index) in checkstationList" :key="index" :value="item.checkstationId">{{item.checkstationName}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">设备：</div>
						<a-select v-model="query.deviceId">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="(item, index) in checkdeviceList" :key="index" :value="item.checkdeviceId">{{item.checkdeviceName}}</a-select-option>
						</a-select>
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">查询日期：</div>
						<a-date-picker v-model="query.startTime" format="YYYY-MM-DD" class="qinang-search-time-picker-2" />
						<span style="width: 20px;text-align: center;">-</span>
						<a-date-picker class="qinang-search-time-picker-2" v-model="query.endTime" format="YYYY-MM-DD" />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">订单编号：</div>
						<a-input placeholder="请输入订单编号" v-model="query.ordersNumber"  />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">票号：</div>
						<a-input placeholder="请输入票号" v-model="query.ticketNumber"  />
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">门票名称：</div>
						<a-input placeholder="请输入门票名称：" v-model="query.productName"  />
					</div>
					<div class="qinang-search-col-3">
						<a-button type="primary" icon="search" @click="apiOrdersQueryListByCheck">查询</a-button>
						<a-button icon="redo" @click="resetQuery" style="margin-left: 14px;">重置</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :columns="tableColumns" :data-source="tableData" row-key="ordersNumber"
				:loading="tableLoading" :pagination="false">
				<span slot="ordersTotal" slot-scope="ordersTotal">
					{{ordersTotal.ordersTotal / 100}}
				</span>
				<span slot="createTime" slot-scope="createTime">
					{{qaUtil.timeFormat(createTime.createTime)}}
				</span>
				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" @click="OrderDetails(tableAction)" >详情</a-button>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>
		<a-modal  class="qa-modal" width="100%"  title="订单详情" :visible="detailsVisible" @ok="detailsVisible=false" @cancel="detailsVisible=false" :maskClosable="false" :keyboard="false">
			<OrderInfo v-if="detailsVisible" :ordersNumber="ordersNumber"></OrderInfo>
		</a-modal>


		
	</div>
</template>

<script>
	import moment from 'moment'
	import OrderInfo from './OrderInfo.vue';
	export default {
		components: {
			OrderInfo,
		},
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				detailsVisible:false,
				ordersNumber:undefined,
				facilitatorList: [],//服务商列表
				checkstationList:[],//园门
				checkdeviceList:[],//设备
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: 0,
					checkstationId: 0,
					deviceId: 0,
					startTime: undefined,
					endTime: undefined,
					operateType: 4,
					ordersNumber: undefined,
					ticketNumber:undefined,
				},
	
				tableData: [],
				tableColumns: [
					{
						title: '订单编号',
						dataIndex: 'ordersNumber',
						key: 'ordersNumber',
						align: 'center'
					},
					{
						title: '票号',
						dataIndex: 'ticketNumber',
						key: 'ticketNumber',
						align: 'center'
					},
					{
						title: '门票名称',
						dataIndex: 'productName',
						key: 'productName',
						align: 'center',
					},
					
					{
						title: '园门',
						dataIndex: 'checkstationName',
						key: 'checkstationName',
						align: 'center',
					},
					{
						title: '设备',
						dataIndex: 'checkdeviceName',
						key: 'checkdeviceName',
						align: 'center',
					},
					{
						title: '检票数量',
						dataIndex: 'operateQuantity',
						key: 'operateQuantity',
						align: 'center',
					},
					{
						title: '操作时间',
						key: 'createTime',
						align: 'center',
						scopedSlots: {
							customRender: 'createTime'
						}
					},
					{
						title: '操作',
						key: 'tableAction',
						align: 'center',
						scopedSlots: {
							customRender: 'tableAction'
						}
					},

				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
		
			};
		},
		methods: {
			async apiFacilitatorListForStaff() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorListForStaff, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
				} else {

				}
			},
			facilitatorChange(e) {
				if(e == 0) {
					this.checkstationList = []
				}else {
					this.apiCheckstationList()
				}
				this.query.checkstationId = 0
				this.query.deviceId = 0
			},
			async apiCheckstationList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckstationList, {facilitatorId:this.query.facilitatorId});
				if (res.code == 200) {
					this.checkstationList = res.data
				} else {
			
				}
			},
			checkstationChange(e){
				if(e == 0) {
					this.checkdeviceList = []
				}else {
					this.query.checkstationId = e
					this.apiCheckDeviceList()
				}
				this.query.deviceId = 0
			},
			async apiCheckDeviceList(){
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckDeviceList, {checkstationId:this.query.checkstationId});
				if (res.code == 200) {
					this.checkdeviceList = res.data
				} else {
			
				}
			},

			async apiOrdersQueryListByCheck() {
				let queryData = this.query
				if(this.query.facilitatorId > 0 && this.query.checkstationId > 0 && this.query.deviceId == 0){
					const deviceIds = this.checkdeviceList.map(it => (it.checkdeviceId))
					queryData.deviceIdList = deviceIds
				}else{
					queryData.deviceIdList = undefined
				}
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiOrdersQueryListByCheck, queryData);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiOrdersQueryListByCheck()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiOrdersQueryListByCheck()
			},
			resetQuery(){
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: 0,
					checkstationId: 0,
					deviceId: 0,
					startTime: undefined,
					endTime: undefined,
					operateType: 4,
					ordersNumber: undefined,
					ticketNumber:undefined,
				}
				this.apiOrdersQueryListByCheck()
			},

			
			tableSee() {
				if(this.tableSelectedRows.dutyId > 0) {
					// this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			OrderDetails(item) {
				this.ordersNumber = item.ordersNumber
				this.detailsVisible = true
			},
			
		},
		computed: {
			
		},
		created() {
			this.apiFacilitatorListForStaff()
			this.apiOrdersQueryListByCheck()
		}
	};
</script>

<style scoped>
	

</style>
